// extracted by mini-css-extract-plugin
export var dropdown = "_e5-0";
export var imagePlaceholder = "_e5-2";
export var imageWrapper = "_e5-3";
export var productImage = "_e5-1";
export var truncateContainer = "_e5-4";
export var truncateText = "_e5-5";